<template>


    <Transition name="modal-fade">
      <div v-if="isdisplay" class="cf-overlay" @click.self="close">
        <Transition name="modal-slide">
          <div v-if="isdisplay" class="cf-dialog cf-dialog--xxl">

                <!-- Header -->
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-file-list-3-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                            <p class="cf-modal-head__sub">Rapports des articles par bon</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>

                <!-- Body -->
                <div class="cf-dialog-body">



                    <div class="box  overflow-hidden">
                        <div class="box-header justify-between " style="display: block">

                            <div class="grid grid-cols-12  gap-x-6">

                                <div class="xl:col-span-12 mt-3  col-span-12">
                                    <div class="cf-note cf-note--info">
                                      RAPPORT ARTICLE PAR DOCUMENT VENTE
                                    </div>

                                </div>

                                <div class="xl:col-span-4 mt-3  col-span-12">
                                    <input @change="load" v-model="datedebut" type="date" class="form-control" >
                                </div>
                                <div class="xl:col-span-4 mt-3  col-span-12">
                                    <input @change="load" v-model="datefin" type="date" class="form-control" >
                                </div>

                                <div class="xl:col-span-4 mt-3  col-span-12">

                                    <select class="form-control"   @change="load()" v-model="selectedclient">
                                        <option :value="null">Séléctionner un produit</option>
                                        <option value='all'>Tout les Articles / services</option>
                                        <option v-for="(client,index) in dataclient" :value="client" :key="index">{{client.libelle}}</option>

                                    </select>

                                </div>

                                <div class="xl:col-span-12 mt-3  col-span-12">

                                    <select   @change="load()" class="form-control"  v-model="selecteddocument">

                                        <option value='null'>Séléctionner un document de vente</option>
                                        <option value="BCLT">BON DE COMMANDE CLT</option>
                                        <option value="BONPREPARATIONLIVRAISON">BON DE PREPARATION DE LIVRAISON</option>
                                        <option value="BONLIVRAISON">BON DE LIVRAISON</option>
                                        <option value="FACTURECLT">FACTURE CLT</option>
                                        <option value="FACTUREAVOIRCLT">FACTURE D'AVOIR CLT</option>
                                        <option value="BONRETOURCLT">BON DE RETOUR CLT</option>
                                        <option value="FACTUREAVOIRCLT">FACTURE D'AVOIR CLT</option>

                                        <!--option value="BON DE COMMANDE FRS">BON DE COMMANDE FRS</option>
                                        <option value="FACTURE D'AVOIR FRS">FACTURE D'AVOIR FRS</option>
                                        <option value="BON DE RETOUR FRS">BON DE RETOUR FRS</option>
                                        <option value="BON DE RECEPTION FRS">BON DE RECEPTION FRS</option>
                                        <option value="DEVIS/PROFORMA">DEVIS/PROFORMA</option>
                                        <option value="DEMANDE D'ACHAT">DEMANDE D'ACHAT</option-->



                                    </select>

                                </div>



                            </div>

                            <div class="w-full flex grid-cols-2 mt-4">

                                <div class="inline-flex rounded-md shadow-sm" role="group" aria-label="Basic example">

                                    <div class="grid lg:grid-cols-2 gap-6">

                                        <div class="space-y-2">

                                            <button @click="ExportExcel('xlsx',titlemodal+'-'+selecteddocument)"  class="ti-btn ti-btn-success-full w-full"><i class="ri-file-excel-fill"></i> Exporter en excel</button>

                                        </div>

                                        <div class="space-y-2">
                                            <button @click="apercuavantimpression(titlemodal,'exportable_table')"  class="ti-btn ti-btn-primary-full w-full"><i class="ri-printer-fill"></i> Aperçu avant impression</button>

                                        </div>





                                    </div>


                                </div>
                            </div>

                        </div>



                            <div class="table-responsive">

                                <div class="flex flex-col h-screen tableFixHeadindexcomponnent">
                                    <div class="flex-grow overflow-auto">

                                   <table ref="exportable_table" class="relative w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>

                                                <th  scope="col" class="th text-start">N°</th>
                                                <th  scope="col" class="th text-start">Créer par</th>
                                                <th  scope="col" class="th text-start">Date</th>
                                                <th  scope="col" class="th text-start">Reference</th>
                                                <th  scope="col" class="th text-start">N° Bon </th>
                                                <th  scope="col" class="th text-start">Article / service</th>
                                                <th  scope="col" class="th text-start">Taux AIB</th>
                                                <th  scope="col" class="th text-start">Quantitité</th>
                                                <th  scope="col" class="th text-start">Montant HT (FCFA)  </th>
                                                <th  scope="col" class="th text-start">Montant TVA (FCFA)  </th>
                                                <th  scope="col" class="th text-start">Montant  AIB (FCFA) </th>
                                                <th  scope="col" class="th text-start">Montant  TTC (FCFA) </th>

                                            </tr>
                                            </thead>
                                            <tbody>


                                                <template v-if="tableview2.length">

                                                    <tr class="border-t hover:bg-gray-200 dark:hover:bg-light" style="font-weight: 600;/*background: khaki;*/"
                                                        v-for="(datavalue,index) in tableview2[0].datas" :key="index">


                                                        <td  data-label="N°  : "   >{{ index+1 }}</td>
                                                        <td  data-label="Créer par : "   >{{ datavalue.creerpar }}</td>
                                                        <td  data-label="Date : "   >{{ datavalue.datedoc }}</td>
                                                        <td  data-label="Réference : "   >{{ datavalue.reference }}</td>
                                                        <td  data-label="N° Bon : "   >{{ datavalue.otherref }}</td>
                                                        <td  data-label="Article / service : "   >{{ datavalue.article }}</td>
                                                         <td  data-label="Taux AIB  : "   >{{ datavalue.tauxaib }}</td>
                                                        <td  data-label="Quantitité  : "   >{{ datavalue.qte }}</td>
                                                        <td  data-label="Montant HT  : "   >{{ FormatNumber(datavalue.montantht) }}</td>
                                                        <td  data-label="Montant TVA : "   >{{ FormatNumber(datavalue.montanttva) }}</td>
                                                        <td  data-label="Montant AIB : "   >{{ FormatNumber(datavalue.montantaib) }}</td>
                                                        <td  data-label="Montant TTC : "   >{{ FormatNumber(datavalue.montantttc) }}</td>



                                                    </tr>

                                                </template>

                                                <template v-else>
                                                    <tr >
                                                        <td class="border-t hover:bg-gray-200 dark:hover:bg-light" colspan="20"><div class="alert alert-danger">Aucune donnée trouvée</div></td>
                                                    </tr>

                                                </template>


                                            </tbody>


                                       <template v-if="tableview2.length">
                                           <tfoot>
                                           <tr style="font-weight: 600;/*background: khaki;*/">
                                               <td colspan="7" data-label="Total"><h2>Total</h2></td>
                                               <td data-label="Quantite total"><span>{{FormatNumber(tableview2[0].totalquantite)}}</span></td>
                                               <td data-label="Montant total HT"><span>{{FormatNumber(tableview2[0].totalmontantht)}}</span></td>
                                               <td data-label="Montant total TVA"><span>{{FormatNumber(tableview2[0].totalmontanttva)}}</span></td>
                                               <td data-label="Montant total AIB"><span>{{FormatNumber(tableview2[0].totalmontantaib)}}</span></td>
                                               <td data-label="Montant TTC"><span>{{FormatNumber(tableview2[0].totalmontantttc)}}</span></td>
                                           </tr>
                                           </tfoot>

                                       </template>


                                        </table>

                                    </div>
                                </div>

                            </div>



                    </div>






                </div>
                <!-- Footer -->
                <div class="cf-dialog-foot">
                    <button @click="apercuavantimpression(titlemodal,'exportable_table')" type="button" class="ti-btn ti-btn-primary-full"><i class="ri-printer-line align-middle"></i> Aperçu avant impression</button>
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                </div>

          </div>
        </Transition>
      </div>
    </Transition>


    <modalprintdefault ref="modalprintdefault"></modalprintdefault>

</template>

<script>


    const axios =require('axios');

    import modalprintdefault from "@/components/views/pages/modal_printdefault";
    import {currentDateTime, ExportExcel, FormatNumber, groupByKey, randomString, triecroissant} from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },

            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

            },


        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

                let t=this


                t.montanttotalht=0
                t.montanttotaltva=0
                t.montanttotalaib=0
                t.montanttotalremise=0
                t.montanttotal=0
                t.montanttotalrestant=0
                    mvalue.forEach(function (post) {
                    t.montanttotalht=parseInt(t.montanttotalht)+parseInt(post.montantht)
                    t.montanttotaltva=parseInt(t.montanttotaltva)+parseInt(post.montanttva)
                    t.montanttotalaib=parseInt(t.montanttotalaib)+parseInt(post.montantaib)
                    t.montanttotalremise=parseInt(t.montanttotalremise)+parseInt(post.montantremise)
                    t.montanttotal=parseInt(t.montanttotal)+parseInt(post.debit)
                    t.montanttotalrestant=parseInt(t.montanttotalrestant)+parseInt(post.credit)
                })


                return mvalue ;
                //return this.paginate(mvalue) ;
            },
        },
        components: {
            modalprintdefault

        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                mmontanttotal:0,

                montanttotalremise:0,
                montanttotalht:0,
                montanttotaltva:0,
                montanttotalaib:0,
                montanttotal:0,
                montanttotalrestant:0,

                dmontanttotalht:0,
                dmontanttotaltva:0,
                dmontanttotalaib:0,
                dmontanttotal:0,

                datedebut:this.$store.state.appserverdate,
                datefin:this.$store.state.appserverdate,
                dataclient:[],
                datatable:[],
                tableview1:[],
                tableview2:[],
                tableview:'1',

                selecteddocument:null,
                selectedclient:null,



                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {

            ExportExcel(type,name, fn, dl) {
                name=name+"_"+currentDateTime()
                var elt = this.$refs.exportable_table;
                ExportExcel(type,name, fn, dl,elt);

            },


            apercuavantimpression(valuetitre,tableref){
                let $tableref=this.$refs[tableref];


                let tabvalue={
                    titres:valuetitre,
                    numdoc:'',
                    date:currentDateTime(),
                    datedebut:this.datedebut,
                    datefin:this.datefin,
                    total1:0,
                    total2:0,
                    total3:0,
                    total4:0,
                    tableref:$tableref.toString(),
                }

                this.$refs.modalprintdefault.show(tabvalue,$tableref);



            },




            async load(){

                if (this.selectedclient===null || this.selecteddocument===null){

                    return

                }


                if (this.datedebut===null || this.datedebut==="" ||
                    this.datefin===null || this.datefin==="" ){

                    return

                }

                let pidcltfrs

                if (this.selectedclient==='all'){

                    pidcltfrs='all'
                }else{
                    pidcltfrs=this.selectedclient.keyline
                }



                this.$store.dispatch('lancerchargement',true)

                const t = this;

                let url=process.env.VUE_APP_API_URL+'/compta/edition/rapportitemsdoc/'+this.selecteddocument+'/'+this.datedebut+'/'+this.datefin+'/'+pidcltfrs+'/'+this.$store.state.appsociete+'/'+randomString();

                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification

                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){
                            let $groupebyyearmonth=groupByKey(res.data.datas,'yearandmonth');
                            var $datares=[];
                            var $datares2=[];


                            for ( let [$index, $lineyearmonth]   of Object.entries($groupebyyearmonth)){

                                let datavalues=[];


                                let $groupebynormalisation=groupByKey($lineyearmonth,'normalisation');
                                for ( let [$indexnormalisation, $linenormalisation]   of Object.entries($groupebynormalisation)){ //grouper les facture suivants letat de normalisation

                                    let $datanormalisation=[],
                                        $linenormalisationmontantttc=0,
                                        $linenormalisationmontantht=0,
                                        $linenormalisationmontanttva=0,
                                        $linenormalisationmontantaib=0,
                                        $linenormalisationqtite=0;


                                    let $groupebyarticles=groupByKey($linenormalisation,'keyarline');
                                    for ( let [$indexarticle, $linearticles]   of Object.entries($groupebyarticles)){ // grouper par article

                                        let datavaluearticles=[];
                                        let $namearticles="",
                                            $tauxaib=0,
                                            $montantttc=0,
                                            $montantht=0,
                                            $montanttva=0,
                                            $qte=0,
                                            $montantaib=0;


                                        for(let $mlinearticle of $linearticles){

                                            $namearticles=$mlinearticle.article;
                                            $qte=parseFloat($mlinearticle.qtite)+parseFloat($qte);
                                            $tauxaib=parseFloat($mlinearticle.tauxaib);

                                            $montantht=parseFloat($mlinearticle.mtntht)+parseFloat($montantht);

                                            let tauxtva=parseFloat($mlinearticle.tauxtva);
                                            let mtva=parseFloat($mlinearticle.mtntht)*tauxtva

                                            let mmontantaib=0

                                            if ($tauxaib>0){
                                                mmontantaib=parseFloat($mlinearticle.mtntht)*($tauxaib/100)
                                            }

                                            let mmontantttc=parseFloat($mlinearticle.mtntht)+mtva+mmontantaib;

                                            $montanttva= parseFloat(mtva)+parseFloat($montanttva);
                                            $montantttc=parseFloat(mmontantttc)+parseFloat($montantttc);
                                            $montantaib=parseFloat(mmontantaib)+parseFloat($montantaib);


                                        }



                                        $linenormalisationmontantttc=parseFloat($linenormalisationmontantttc)+parseFloat($montantttc)
                                        $linenormalisationmontantht=parseFloat($linenormalisationmontantht)+parseFloat($montantht)
                                        $linenormalisationmontanttva=parseFloat($linenormalisationmontanttva)+parseFloat($montanttva)
                                        $linenormalisationmontantaib=parseFloat($linenormalisationmontantaib)+parseFloat($montantaib)
                                        $linenormalisationqtite=parseFloat($linenormalisationqtite)+parseFloat($qte)

                                        $datanormalisation.push({
                                            normalisation:$linearticles[0].normalisation,
                                            article:$namearticles,
                                            tauxaib:$tauxaib,
                                            montantht:$montantht,
                                            montantttc:$montantttc,
                                            montanttva:$montanttva,
                                            montantaib:$montantaib,
                                            qte:$qte,
                                            dataarticles:$linearticles
                                        })

                                        //  console.log("datavalues----------------  11111111111111111   ",datavalues)

                                    }



                                    datavalues.push({
                                        etatnormalisation:$linenormalisation[0].normalisation,
                                        datasnormalisation:$datanormalisation,
                                        linenormalisationmontantttc:$linenormalisationmontantttc,
                                        linenormalisationmontantht:$linenormalisationmontantht,
                                        linenormalisationmontanttva:$linenormalisationmontanttva,
                                        linenormalisationmontantaib:$linenormalisationmontantaib,
                                        linenormalisationqtite:$linenormalisationqtite,

                                    })

                                }

                                $datares.push({
                                    yearmonth:$index,
                                    datas:datavalues
                                })


                            }


                            t.tableview1=$datares

                            $datares2=triecroissant(res.data.datas,'article');


                            t.tableview2=[];
                            let $newarraytableview2=[];
                            let
                                $totalquantite=0,
                                $totalmontantht=0,
                                $totalmontanttva=0,
                                $totalmontantaib=0,
                                $totalmontantttc=0;
                            for (let $line of $datares2){


                                let $tauxaib=parseFloat($line.tauxaib);

                                let $montantht=parseFloat($line.mtntht);

                                let tauxtva=parseFloat($line.tauxtva);
                                let mtva=parseFloat($montantht)*tauxtva

                                let mmontantaib=0

                                if ($tauxaib>0){
                                    mmontantaib=parseFloat($montantht)*($tauxaib/100)
                                }

                                let mmontantttc=parseFloat($montantht)+mtva+mmontantaib;



                                $newarraytableview2.push({
                                    otherref:$line.otherref,
                                    reference:$line.reference,
                                    creerpar:$line.creepar,
                                    creerle:$line.linecreatedat,
                                    datedoc:$line.doccreatedat,
                                    article:$line.article,
                                    normalisation:$line.normalisation,
                                    tauxaib:$line.tauxaib,
                                    qte:$line.qtite,
                                    montantht:$line.mtntht,
                                    montanttva:mtva,
                                    montantaib:mmontantaib,
                                    montantttc:mmontantttc,
                                })


                                $totalquantite=parseFloat($totalquantite)+parseFloat($line.qtite),
                                $totalmontantht=parseFloat($totalmontantht)+parseFloat($line.mtntht),
                                    $totalmontanttva=parseFloat($totalmontanttva)+parseFloat(mtva),
                                    $totalmontantaib=parseFloat($totalmontantaib)+parseFloat(mmontantaib),
                                    $totalmontantttc=parseFloat($totalmontantttc)+parseFloat(mmontantttc);


                            }


                            t.tableview2.push({
                                datas:$newarraytableview2,
                                totalmontantht:$totalmontantht,
                                totalmontanttva:$totalmontanttva,
                                totalmontantaib:$totalmontantaib,
                                totalmontantttc:$totalmontantttc,
                                totalquantite:$totalquantite,
                            })

                            //t.listecatalogue=$datares;





                        }
                        else{
                            t.datatable=[];
                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },

            async loadclient(){

                const t = this;
                let url=process.env.VUE_APP_API_URL+'/ar85474524otherdatadofodfidfoioienf55485/compta/'+this.$store.state.appsociete+'/'+randomString();
                let response =   axios  .get(url,{
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + JwtService.getToken(),
                        'csrftoken': this.$store.state.appsociete
                    } ,withCredentials: true // Permet l'envoi de cookies et autres informations d'authentification
                })

                let res= await response
                    .then(function (res){
                        t.$store.dispatch('lancerchargement',false)


                        if(res.data.success){



                            t.dataclient=[];
                            t.dataclient=res.data.m;


                        }
                        else{
                            t.dataclient=[];
                        }


                    })
                    .catch((error)=>{

                            t.$store.dispatch('lancerchargement',false)
                        }
                    )
                    .finally(() =>{

                        t.$store.dispatch('lancerchargement',false)


                    })




            },

            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            show(){


                this.messagesucces="";
                this.messageerror="";


              this.titlemodal="  RAPPORT ARTICLE PAR DOCUMENT VENTE" ;



                this.datatable=[];
                this.dataclient=[];

                this.loadclient();
                this.selecteddocument=null;
                this.isdisplay=true;





            },


            FormatNumber(num) {

                return  FormatNumber(num)
            },



            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xxl { max-width:1150px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.th { position:sticky; top:0; z-index:2; padding:0.7rem 1rem; font-weight:600; font-size:0.75rem; color:var(--cf-ink); background:var(--cf-surface-alt); border-bottom:1px solid var(--cf-border); white-space:nowrap; letter-spacing:0.02em; text-align:left; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

    .table td {
        cursor: pointer;
    }

    .h-screen{

        height: 300px!important;

    }

    .mybodyheight200px{
        height: 200px;
    }

    .mybodyheight300px{
        height: 300px;
    }

    .mybodyheight400px{
        height: 400px;
    }

    .mybodyheight500px{
        height: 500px;
    }

    @media screen and (max-width: 768px) {

        .cf-dialog--xxl { max-width:100%; }

        .h-screen,.mybodyheight200px,.mybodyheight300px, .mybodyheight400px,.mybodyheight500px{
            height: 100%!important;
        }


    }

</style>